import { Box } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { useBusiness } from 'hooks/useBusiness';
import createHeaderTheme from 'themes/createHeaderTheme';

interface HeaderThemeProviderProps {
	children: React.ReactNode;
}

const HeaderThemeProvider = ({ children }: HeaderThemeProviderProps) => {
	const { getBizConfigVar } = useBusiness();
	const colors = getBizConfigVar('colors');

	// Now we can dynamically create our theme with the specific business colors
	const headerTheme = createHeaderTheme(colors);

	return (
		<ThemeProvider theme={headerTheme}>
			<Box sx={{ backgroundColor: `#${colors.headerBgsBtns}` }}>
				{children}
			</Box>
		</ThemeProvider>
	);
};

export default HeaderThemeProvider;
